<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Sample" :label-cols="3">
          <b-form-input
            type="text"
            v-model="identifier"
            :state="!$v.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Sample Usage"
          :label-cols="3"
          :state="!$v.sample_form.sample_water.usage.$invalid"
          invalid-feedback="Required"
        >
          <form-selector
            :selectedItem="sample_form.sample_water.usage"
            customPlaceholder="Select Sample Usage"
            :options="usageOptions"
            @change="handleSelect"
          ></form-selector>
        </b-form-group>
      </b-col>
    </b-row>
    <add-on-select
      :selectedAddOns="sample_form.add_ons"
      :addOns="addOns"
      @onAddOnSelect="onAddOnSelect"
    ></add-on-select>
  </div>
</template>

<script>
import AddOnSelect from "../../AddOnSelect";
import FormSelector from "../../FormSelector";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "WaterSampleFormGroup",
  components: {
    AddOnSelect,
    FormSelector
  },
  mixins: [validationMixin, ToastNotifications],
  props: ["sample", "addOns", "index", "usageOptions"],
  computed: {
    identifier: {
      get() {
        return this.sample_form.identifier;
      },
      set(value) {
        this.sample_form.identifier = value;
        this.handleSampleChange();
      }
    }
  },
  data() {
    return {
      sample_form: {
        test_package_sample_id: null,
        identifier: null,
        add_ons: [],
        sample_water: {
          usage: null
        }
      }
    };
  },
  validations: {
    identifier: { required },
    sample_form: {
      sample_water: {
        usage: { required }
      }
    }
  },
  methods: {
    handleSampleChange() {
      const params = { ...this.sample_form };
      this.$emit("onSampleChange", {
        sample: params,
        index: this.index
      });
    },
    onAddOnSelect(addOns) {
      this.sample_form.add_ons = [...addOns];
      this.handleSampleChange();
    },
    handleSelect({ selected, field }) {
      this.sample_form.sample_water[field] = selected;
      this.handleSampleChange();
    }
  },
  beforeMount() {
    const form_data = JSON.parse(JSON.stringify(this.sample));
    if (form_data && form_data.test_package_sample_id) {
      const {
        test_package_sample_id,
        identifier,
        add_ons,
        sample_water
      } = form_data;
      this.sample_form = {
        test_package_sample_id,
        identifier,
        add_ons: (add_ons && [...add_ons]) || [],
        sample_water: { ...sample_water }
      };
    }
  }
};
</script>
